module.exports = __webpack_public_path__ + "img/2.2773b8c6.png";